var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-loader-graphic"},[_c('LensFlare',{staticClass:"w-full h-full",staticStyle:{"max-width":"260px","max-height":"260px"},attrs:{"id":`c-loader-graphic-flare-${_vm._uid}`,"angle":45,"min-blur-amount":25,"max-blur-amount":25,"flares":[
			{
				size: 480,
				offset: 0,
				opacity: 1,
				theme: 'primary',
				classes: ['c-loader-graphic__flare-first'],
			},
			{
				size: 360,
				offset: -160,
				opacity: 0.7,
				theme: 'secondary',
				classes: ['c-loader-graphic__flare-second'],
			},
			{
				size: 280,
				offset: 60,
				opacity: 0.7,
				theme: 'secondary',
				classes: ['c-loader-graphic__flare-third'],
			},
			{
				size: 160,
				offset: 200,
				opacity: 0.6,
				theme: 'secondary',
				classes: ['c-loader-graphic__flare-fourth'],
			},
		]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }